<template>
  <ConfigProvider
    :theme-vars="{
      popupCloseIconColor: '#666',
    }"
  >
    <BasePopup
      class="market-select-modal"
      v-model:show="visible"
      :closeOnClickOverlay="true"
      :showFillBar="true"
      round
      closeable
      @click-overlay="$emit('toggleMarketSelectModalVisible', false)"
      @click-close-icon="$emit('toggleMarketSelectModalVisible', false)"
    >
      <!--header-->
      <div class="header">
        <h3 class="header-title">{{ MARKET_IFON[type]?.title }}</h3>
      </div>
      <ProductLocation
        v-if="relatedPlace"
        :related-place="relatedPlace"
        @change="(val) => $emit('changeMorningPaperLocation', val)"
      />
      <MarketList
        :type="type"
        :maxSeclectCount="maxSeclectCount"
        :selectedMarketList="props.selectedMarketList"
        :productConfigType="props.productConfigType"
        @handleMarketTypeSelect="(item) => $emit('handleMarketTypeSelect', item)"
      />
    </BasePopup>
  </ConfigProvider>
</template>

<script setup lang="ts" name="BaseMarketSelect">
  import { computed } from 'vue';
  import BasePopup from '../base-popup/index.vue';
  import { MARKET_TYPE, MARKET_IFON } from './contsants';
  import MarketList from './market-list.vue';
  import { ConfigProvider } from 'vant';
  import ProductLocation from './product-location/index.vue';

  const props = defineProps<{
    relatedPlace?: 'top' | 'bottom';
    type: MARKET_TYPE;
    visibleMarketTypeSelect: boolean;
    maxSeclectCount: number;
    selectedMarketList?: any[];
    productConfigType?: number;
  }>();

  const visible = computed(() => props.visibleMarketTypeSelect);

  defineEmits(['handleMarketTypeSelect', 'toggleMarketSelectModalVisible', 'changeMorningPaperLocation']);
</script>

<style lang="less">
  .market-select-modal {
    box-sizing: border-box;
    height: 95vh;
    padding: 0 0.3rem;
    font-family: PingFangSC-Regular, 'PingFang SC';
    background-color: #fff;
    .header {
      padding-top: 10px;
      line-height: 1;
      text-align: center;
      &-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000a18;
        margin: 10px 0;
      }
    }
  }
</style>
